
type Props = {
	readonly title?: string;
	readonly className?:  string;
	readonly children?: React.ReactNode;
};


export const LegalSection = ({ title, className, children }: Props) => (
	<section className={`c-pnp-legal-section ${className ?? ''}`}>
		<h2 className="c-pnp-legal-section__title">{title}</h2>
		<div>{children}</div>
	</section>
);
